import * as React from "react";
import { useCallback } from "react";
import Routes from "routing/Routes";
import { MenuItem } from "components/bootstrap";
import { isSigmaEventDefinition } from "components/event-definitions/event-definitions-types";
const SigmaEventDefinitionSearchAction = ({ entity }) => {
  var _a;
  const eventDefinition = entity;
  const isSigma = isSigmaEventDefinition(eventDefinition);
  const onSearchLogs = useCallback(() => {
    window.open(Routes.ALERTS.DEFINITIONS.replay_search(eventDefinition.id), "_blank");
  }, [eventDefinition.id]);
  if (!isSigma) return null;
  const canSearch = !!((_a = eventDefinition == null ? void 0 : eventDefinition.config) == null ? void 0 : _a.query);
  return /* @__PURE__ */ React.createElement(MenuItem, { disabled: !canSearch, onClick: canSearch ? onSearchLogs : void 0 }, "Replay Search");
};
export default SigmaEventDefinitionSearchAction;
